import { Box } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import { Clipboard, FlatList } from 'react-native'
import ic_copy from '../../../assets/images/ic_copy.png'
import ic_lock from '../../../assets/images/ic_lock.png'
import EmptyView from '../../../comps/EmptyView'
import { useLazyApiData, useStores } from '../../../data/store'
import { ErrorBoundary } from './ErrorBoundary'
import { ListItem } from './ListItem'
import styles from './styles'
import { ValidateOTPModel } from './ValidateOTPModal'

const ApiCredentialsTab = () => {
  const [isEncryped, setEncrpted] = useState(true)

  const { mid, setMessage, setBgColor, userSettingsApi, sendOTPApi, getOTPAuthCode, mobileNum, getApiCredList } =
    useStores((root) => ({
      setMessage: root.response.setMessage,
      setBgColor: root.response.setBgColor,
      userSettingsApi: root.settings.fetchUserSettings,
      sendOTPApi: root.settings.sendOTP,
      getOTPAuthCode: root.settings.getOTPAuthCode,
      mobileNum: root.settings.metaData.mobileNumber,
      getApiCredList: root.settings.getApiCredList,
      mid: root.user.selectedMid,
    }))

  const [fetchUserSettings, fetchUserSettingsHandler = { data: [], state: undefined }] = useLazyApiData(userSettingsApi)

  const [isModelDialogVisible, setIsModelDialogVisible] = useState(false)
  const loadingState = fetchUserSettingsHandler.state === 'pending'
  const errorState = fetchUserSettingsHandler?.data?.message ?? false
  const [isDialogLoading, setIsDialogLoading] = useState(false)
  const [submitOtpError, setSubmitOtpError] = useState('')

  useEffect(() => {
    if (mid) {
      fetchUserSettings()
    }
    return () => {
      setBgColor('')
    }
  }, [fetchUserSettings, mid, setBgColor])

  const apiCredList = getApiCredList()

  const handleRetry = (): void => {
    fetchUserSettings()
  }

  const flatListItemSeparator = () => {
    return <Box height={1} width={'100%'} backgroundColor="BORDER_COLOR" />
  }

  const onDismiss = () => {
    setIsModelDialogVisible(false)
  }

  const onOTPEntered = async (otp: string) => {
    setIsDialogLoading(true)

    const res = await getOTPAuthCode(otp)
    setIsDialogLoading(false)
    if (res && !res.error && Object.keys(res).length > 0) {
      apiCredList[2].iconId = ic_copy
      apiCredList[2].iconAction = 'COPY_ENCRYPT'
      setIsModelDialogVisible(false)
      setEncrpted(false)
    } else {
      setSubmitOtpError(res.error)
    }
  }

  const resendOTP = async () => {
    const res = await sendOTPApi(mobileNum)
    if (res.status === 'INITIATED') {
      setBgColor('BLACK_75')
      setMessage('OTP Sent')
    }
  }

  const _renderItem = ({ item, index }: any) => {
    return <ListItem item={item} isEncryped={isEncryped} onListItemAction={onListItemAction} index={index} />
  }

  const onListItemAction = async (item: any) => {
    if (item.iconAction === 'LOCK' && isEncryped) {
      const res = await sendOTPApi(mobileNum)
      if (res.status === 'INITIATED') {
        setIsModelDialogVisible(true)
      }
    } else {
      if (item.iconAction === 'LOCK' && !isEncryped) {
        item.iconAction = 'LOCK'
        item.iconId = ic_lock
        setEncrpted(true)
      }

      Clipboard.setString(item.value)
      setBgColor('BLACK_75')
      setMessage(`${item.title} copied to the clipboard`)
    }
  }
  return (
    <>
      <ValidateOTPModel
        testID="validate_model"
        isModelDialogVisible={isModelDialogVisible}
        onDismiss={onDismiss}
        onOTPEntered={onOTPEntered}
        resendOTP={resendOTP}
        mobileNum={mobileNum}
        isLoading={isDialogLoading}
        error={submitOtpError}
        setSubmitOtpError={setSubmitOtpError}
      />
      <ErrorBoundary>
        <EmptyView
          testID="emmpty_view"
          onRetry={handleRetry}
          isLoading={loadingState}
          error={errorState}
          loadingMessage="Loading..."
          hide={!loadingState && !errorState}
          loaderColor={'BLUE'}
        />
      </ErrorBoundary>
      {!errorState && !loadingState && (
        <Box {...styles.innerContainer}>
          <FlatList
            testID="cred_list"
            data={apiCredList}
            renderItem={_renderItem}
            ItemSeparatorComponent={flatListItemSeparator}
          />
        </Box>
      )}
    </>
  )
}

export { ApiCredentialsTab }
